/**
 * Created by ued on 2016/11/8.
 */

export default /*start>>>*/{
    "请填写紧急联系人，当出现风险时，我们会主动联系您": "Please enter emergency contact. We will contact you when risk occurs.",
    "补丁更新": "Patch Update",
    "身份认证失败,请重新扫码": "Authentication failed. Please scan QR code again.",
    "上报成功": "Upload successful",
    "身份认证已过期,请重新扫码": "Authentication expired. Please scan QR code again.",
    "公司": "Company",
    "请填写公司": "Please enter name",
    "联系人": "Contact",
    "请填写联系人": "Please enter name",
    "手机": "Mobile phone",
    "请填写手机": "Please enter number",
    "邮箱": "Email",
    "请填写邮箱": "Please enter address",
    "提交": "Submit",
    "跳过": "Skip",
    "提交成功": "Submission successful",
    "当前系统有{0}个补丁未更新,": "{0} patches require update on the system.",
    "建议复制补丁链接，将链接传送到可联网PC，使用PC访问链接下载安装。": "It is recommended to copy patch address to PC with Internet access, then download and install patches via the address.",
    "注：补丁可能存在依赖关系，请按顺序安装。": "Note: Patches may have dependencies. Please install them in order.",
    "影响：": "Impact: ",
    "复制链接": "Copy Link",
    "暂无可用的更新": "No update available",
    "无": "None",
    "重启服务": "Restart service",
    "重启设备": "Restart device",
    "重启网络": "Restart network",
    "手机号格式不正确": "Phone number is invalid.",
    "邮箱格式不正确": "Email address is invalid.",
    "补丁包更新列表": "Patch Pack Update List",
    "上报升级反馈": "Report Upgrade Feedback",
    "暂无数据": "No data available.",
    "扩展功能安装包": "Extension Package",
    "请搜索": "Keyword",
    "更新时间": "Updated",
    "大小": "Size",
    "文件MD5": "File MD5",
    "复制MD5": "Copy MD5",
    "复制下载链接": "Copy Download Link",
    "复制成功": "Copied successfully."
}/*end<<<*/;
